module.exports = __webpack_public_path__ + "fonts/webzuliapack.5c47cfb4.ttf";